import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path
          d="M 56.956999679565435 64.26599884033203 L 40.542999679565426 43.733998840332035 L 55.91299967956543 25.57999884033203 L 45.76299967956543 25.57999884033203 L 32.07499967956543 42.86399884033203 L 32.07499967956543 25.57999884033203 L 23.83899967956543 25.57999884033203 L 23.83899967956543 64.26599884033203 L 32.07499967956543 64.26599884033203 L 32.07499967956543 52.37599884033203 L 35.09099967956543 48.77999884033203 L 46.806999679565436 64.26599884033203 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
